import logo from './logo.svg';
import './App.css';
import { AuthProvider } from "./FireBaseConfig/AuthContext";
import { HashRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar';
import Home from './pages/home';
import List from './pages/list';
import Profile from './pages/profile';
import Saved from './pages/saved';
import About from './pages/about';
import UserAuth from './pages/signOnUp';
import SignUp from './pages/signUp';
import ForgotPassword from './pages/forgotPassword';
import ApproveTransfer from './pages/approveTransfer';

function App() {
  return (
    <AuthProvider>
      <HashRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/list" element={<List />} />
          <Route path="/saved" element={<Saved />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/about" element={<About />} />
          <Route path="/userAuth" element={<UserAuth/>} />
           <Route path="/approve-transfer" element={<ApproveTransfer/>} />
          <Route path="/SignUp" element={<SignUp />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
        </Routes>
      </HashRouter>
    </AuthProvider>
  );
}

export default App;